/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Execute_Output7Inputs */

const en_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tested build`)
};

const ar_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخة مختبرة`)
};

const bn_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টেস্টেড বিল্ড`)
};

const de_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getesteter Build`)
};

const es_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construcción probada`)
};

const fr_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version testée`)
};

const pt_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilação testada`)
};

const zh_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测试版本`)
};

const tr_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test edilmiş yapı`)
};

const ru_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Протестированная сборка`)
};

const pl_svc_browser_extensions_execute_output7 = /** @type {(inputs: Svc_Browser_Extensions_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testowana wersja`)
};

/**
* | output |
* | --- |
* | "Tested build" |
*
* @param {Svc_Browser_Extensions_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_execute_output7 = /** @type {((inputs?: Svc_Browser_Extensions_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_execute_output7(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_execute_output7(inputs)
	if (locale === "de") return de_svc_browser_extensions_execute_output7(inputs)
	if (locale === "es") return es_svc_browser_extensions_execute_output7(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_execute_output7(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_execute_output7(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_execute_output7(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_execute_output7(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_execute_output7(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_execute_output7(inputs)
	return en_svc_browser_extensions_execute_output7(inputs)
});
export { svc_browser_extensions_execute_output7 as "svc_browser-extensions_EXECUTE_output" }